<template>
  <g>
    <g style="transform: scale(0.7)">
    <text transform="matrix(1 0 0 1 320 380)">프로브 {{ number }}</text>
    <g>
      <path class="st0" d="M243.48,494.98c0,0,41.87-3.88,41.87-82.6" />
      <path
          class="st1"
          d="M198.83,404.05c0,1.1-0.9,2-2,2l-27.96-2c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1l27.96-2c1.1,0,2,0.89,2,2 V404.05z"
      />
      <path
          class="st1"
          d="M146.22,496.72c0,1.1-0.9,2-2,2l-27.96-2c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1l27.96-2c1.1,0,2,0.89,2,2 V496.72z"
      />
      <path
          class="st5"
          d="M229.39,410.38c0,1.1-0.9,2-2,2h-24c-1.1,0-2-0.9-2-2v-16.67c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2V410.38z"
      />
      <path
          class="st2"
          d="M290.69,412.67c0,0.65-1.1,1.18-2.46,1.18h-58.98c-1.36,0-2.46-0.53-2.46-1.18v-21.24 c0-0.65,1.1-1.18,2.46-1.18h58.98c1.36,0,2.46,0.53,2.46,1.18V412.67z"
      />
      <path
          class="st2"
          d="M283.96,402.05c0,12.84-2.16,23.25-4.82,23.25c-2.66,0-4.82-10.41-4.82-23.25c0-12.84,2.16-23.25,4.82-23.25 C281.8,378.8,283.96,389.21,283.96,402.05z"
      />
      <path
          class="st2"
          d="M297.46,402.05c0,20.87-2.39,37.79-5.33,37.79c-2.95,0-5.33-16.92-5.33-37.79c0-20.87,2.39-37.79,5.33-37.79 C295.08,364.26,297.46,381.18,297.46,402.05z"
      />
      <path
          class="st3"
          d="M203.66,410.05c0,1.1-0.9,2-2,2l-9.73-4c-0.66,0-1.2-0.54-1.2-1.2v-9.6c0-0.66,0.54-1.2,1.2-1.2l9.73-4 c1.1,0,2,0.89,2,2V410.05z"
      />
      <rect x="295.94" y="387.29" class="st2" width="108.3" height="29.52" />
      <path
          class="st2"
          d="M190.09,505.92h-42.8c-2.55,0-4.62-2.07-4.62-4.62v-13.15c0-2.55,2.07-4.62,4.62-4.62h42.8 c2.55,0,4.62,2.07,4.62,4.62v13.15C194.71,503.85,192.64,505.92,190.09,505.92z"
      />
      <path
          class="st3"
          d="M168.34,508.34h-0.31c-1.11,0-2.01-0.9-2.01-2.01v-23.22c0-1.11,0.9-2.01,2.01-2.01h0.31 c1.11,0,2.01,0.9,2.01,2.01v23.22C170.34,507.44,169.45,508.34,168.34,508.34z"
      />
      <rect x="194.71" y="488.71" class="st2" width="24.38" height="12.02" />
      <polygon class="st2" points="243.48,498.33 219.09,500.73 219.09,488.71 243.48,491.12 " />
      <path
          class="st4"
          d="M479.74,396.14l-27.57-3.2v1.72c0,1.73-1.39,3.15-3.08,3.15h-1.19c-1.69,0-3.08-1.42-3.08-3.15v-2.57 l-4.23-0.49v3.06c0,1.73-1.39,3.15-3.08,3.15h-1.19c-1.7,0-3.08-1.42-3.08-3.15v-3.92l-4.23-0.49v4.41c0,1.73-1.39,3.15-3.08,3.15 h-1.19c-1.7,0-3.08-1.42-3.08-3.15v-5.26l-4.23-0.49v5.75c0,1.73-1.39,3.15-3.08,3.15h-1.19c-1.7,0-3.08-1.42-3.08-3.15v-6.61 l-6.51-0.76v29.52l6.51-0.76v-6.56c0-1.73,1.39-3.15,3.08-3.15h1.19c1.69,0,3.08,1.42,3.08,3.15v5.7l4.23-0.49v-5.21c0-1.73,1.39-3.15,3.08-3.15h1.19c1.7,0,3.08,1.42,3.08,3.15v4.36l4.23-0.49v-3.87c0-1.73,1.39-3.15,3.08-3.15h1.19c1.7,0,3.08,1.42,3.08,3.15v3.01l4.23-0.49v-2.52c0-1.73,1.39-3.15,3.08-3.15h1.19c1.7,0,3.08,1.42,3.08,3.15v1.67l27.57-3.2V396.14z"
      />
      <path
          class="st3"
          d="M413.14,397.8h1.19c1.69,0,3.08-1.42,3.08-3.15v-5.75l-7.36-0.86v6.61C410.06,396.38,411.45,397.8,413.14,397.8z"
      />
      <path
          class="st3"
          d="M424.73,397.8h1.19c1.7,0,3.08-1.42,3.08-3.15v-4.41l-7.36-0.86v5.26C421.65,396.38,423.03,397.8,424.73,397.8z"
      />
      <path
          class="st3"
          d="M436.31,397.8h1.19c1.7,0,3.08-1.42,3.08-3.15v-3.06l-7.36-0.86v3.92C433.23,396.38,434.62,397.8,436.31,397.8z"
      />
      <path
          class="st3"
          d="M447.89,397.8h1.19c1.7,0,3.08-1.42,3.08-3.15v-1.72l-7.36-0.86v2.57C444.81,396.38,446.2,397.8,447.89,397.8z"
      />
      <path
          class="st3"
          d="M414.34,406.35h-1.19c-1.7,0-3.08,1.42-3.08,3.15v6.56l7.36-0.86v-5.7C417.42,407.76,416.03,406.35,414.34,406.35z"
      />
      <path
          class="st3"
          d="M425.92,406.35h-1.19c-1.7,0-3.08,1.42-3.08,3.15v5.21l7.36-0.86v-4.36C429,407.76,427.62,406.35,425.92,406.35z"
      />
      <path
          class="st3"
          d="M437.51,406.35h-1.19c-1.7,0-3.08,1.42-3.08,3.15v3.87l7.36-0.86v-3.01C440.59,407.76,439.2,406.35,437.51,406.35z"
      />
      <path
          class="st3"
          d="M449.09,406.35h-1.19c-1.69,0-3.08,1.42-3.08,3.15v2.52l7.36-0.86v-1.67C452.17,407.76,450.78,406.35,449.09,406.35z"
      />
      <g class="pin">
        <circle
          :id="pincode+'IN'"
          class="pin-cover terminal"
          @click="onClick(`${pincode}IN`)"
          cx="480" cy="402" r="7" />
      </g>
      <g class="pin">
        <circle
          :id="pincode+'PS'"
          class="pin-cover terminal"
          @click="onClick(`${pincode}PS`)"
          cx="170" cy="402" r="5" />
      </g>
      <g class="pin">
        <circle
          :id="pincode+'MS'"
          class="pin-cover terminal"
          @click="onClick(`${pincode}MS`)"
          cx="120" cy="495" r="5" />
      </g>
    </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Probe',
  data () {
    return {
      code: ''
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    }
  }
}
</script>

<style lang="scss" scoped>
.selected {
  > g {
    display: block;
    stroke-width: 1.5px;
    stroke: #ff6f61;
  }
}
.pin-cover {
  stroke-width: 1px;
  stroke: black;
  fill: #ccc;
}
.pin:hover {
  .pin-cover {
    cursor: pointer;
    stroke-width: 1px;
    stroke: black;
    fill: #ff6f61;
  }
}
.st0 {
  fill: none;
  stroke: #000000;
  stroke-width: 3;
  stroke-miterlimit: 10;
}
.st1 {
  fill: #c9caca;
  stroke: #0b0506;
}
.st2 {
  fill: #3e3a39;
}
.st3 {
  fill: #0b0506;
}
.st4 {
  fill: #0f0f0f;
}
.st5 {
  fill: #ff6f61;
  stroke: #0b0506;
}
.end-pointer {
  fill: #c9caca;
  stroke: #0b0506;
  cursor: pointer;
}
.end-pointer:hover {
  fill: #ff6f61;
}
</style>
